import { NumericType, TimeType } from "src/shared/models/metric";
import { TimeInterval } from "src/shared/models/module-manager/module-manager-settings.models";
import { ErrorCode } from "src/shared/models/error-code.model";

// Strings of the different ModuleDisplays
export enum KPITrendModuleDisplay {
  Compact = "compact",
  Detailed = "detailed"
}
export interface IntervalSetting {
  intervalType: TimeInterval;
  intervalAmt: number;
}
export interface CxoneKPITrendModuleData {
  Error: ErrorCode;
  KpiTrendData: CxoneKPITrendWidgetComponentItem[];
  MetricName?: string;
  ViewBy?: string;
  AvgValue?: number;
  DisplayAvgValue?: string;
  DisplayPreviousValue?: string;
  PreviousValue?: string;
  PreviousLabel?: string;
  Color?: string;
  Difference?: number;
  NumericType?: number;
  TimeType?: number;
  ShowDirection?: boolean;
  TrendDisplayValue?: string;
}
export interface CxoneKPITrendWidgetComponentItem {
  MetricId: number;
  MetricName: string;
  Value?: any;
  NumericType?: NumericType;
  TimeType?: TimeType;
  DisplayValue?: string;
  UnitLabel?: string;
  SubLabel?: string;
  Trend?: CxoneKPIWidgetTrend;
  PrevValue?: any;
  PreviousValue?: string;
  PreviousLabel?: string;
  ChartData: { [key: string]: string };
  Objective?: KPITrendObjective;
  Group?: TrendGroup;
  ViewBy?: string;
}

export interface KPITrendObjective {
  Values: number[];
  ColorRange: { RgbaColor: string[], HexColor: string[] };
}

export interface CxoneKPIWidgetTrend {
  Value: any;
  DisplayValue: string;
  ShowDirection: boolean;
  Difference: number;
  Color: string;
}

export interface TrendGroup {
  groupName?: string,
  groupId?: number
}

export interface TrendItem {
  name: string;
  id: number|string;
  selected: boolean;
}

export enum ViewByOptions {
  Team = 'Team',
  Agent = 'Agent',
  Campaign = 'Campaign',
  Skill = 'Skill'
}
